// extracted by mini-css-extract-plugin
export default {"reschedule-detail__container":"styles_reschedule-detail__container__xP-82"};